
import { MdOpenInNew } from "react-icons/md";
import { FaRegCopy } from "react-icons/fa";
import { copyToClipboard } from "../../../Raydium/utils";
import { Link } from "react-router-dom";
import { FaLink } from "react-icons/fa6";
import { FaPhoenixFramework } from "react-icons/fa";
import { BsFillPeopleFill } from "react-icons/bs";
import { TbCreditCardPay } from "react-icons/tb";

import { FaMoneyCheckDollar } from "react-icons/fa6";
import WithdrawProfits from "../WithdrawProfits/WithdrawProfits";
import { useSelector } from "react-redux";
import { selectIcoData, selectUserSessionData } from "../../../../lib/userSessionSlice";
import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "sonner";







export default function AdminMain() {

  const userData = useSelector(selectUserSessionData)
  const icoData = useSelector(selectIcoData)


  function AdminControlls() {
    const endpoint = process.env.REACT_APP_API_BASE_URL + '/ico'

    let config = {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": process.env.REACT_APP_API_KEY
      },

    }

    async function startPhase(phase) {
      toast(`starting Phase ${phase}  please wait ...`)
      let data = {
        phase: phase,
        status:'active',
        started: true
      };

      try {
        const response = await axios.patch(endpoint, data, config).then((res) => res.data.data)
        console.log(response)
        toast(` Phase ${phase}  is Started`)
      } catch (err) {
        toast.error('please try again')
      }
    }
    
    async function endPhase(phase) {
      toast(` Ending phase ${phase}  ...`)
      let data = {
        phase: phase,
        started: false,
        ended:true,
        status:'completed'
      };
      
      try {
        const response = await axios.patch(endpoint, data, config).then((res) => res.data.data)
        toast(` Phase ${phase}  is closed`)
      } catch (err) {
        toast.error('please try again')
      }
    }



    const phase1 = icoData?.[0]
    const phase2 = icoData?.[1]

    return (
      <>
        <div className="flex  gap-5 items-center justify-center bg-neutral-950 shadow-xl w-full p-5 flex-wrap">
        <ChangeDate />
        <ChangeDate2 />

          <div className="flex flex-col gap-2">
          <p>Phase 1</p>
            <button disabled={phase1?.started} onClick={()=> startPhase(1)} className="btn-primary disabled:cursor-not-allowed disabled:bg-neutral-400">Start Phase 1  </button>
            <button disabled={phase1?.ended} onClick={()=> endPhase(1)}className="btn-primary disabled:cursor-not-allowed disabled:bg-neutral-400">End Phase 1   </button>

          </div>
          <div className="flex flex-col gap-2">
          <p>Phase 2</p>

            <button disabled={phase2?.started} onClick={()=> startPhase(2)} className="btn-primary">Start Phase 2  </button>
            <button disabled={phase2?.ended} onClick={()=> endPhase(2)} className="btn-primary">End Phase 2   </button>

          </div>
        </div>

      </>
    )
  }


  const DatePicker = ({ label, value, onChange }) => {
    return (
      <div className="flex flex-col gap-2">
        <label className="text-sm text-neutral-400">{label}</label>
        <input
          type="datetime-local"
          value={value?.slice(0, 16)} // Ensures proper formatting
          onChange={(e) => onChange(e.target.value)}
          className="text-sm text-white bg-neutral-700 px-4 py-2 rounded-md border-none focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
    );
  };
  
  const ChangeDate = () => {
    const [selectedDate, setSelectedDate] = useState(null);

    const endpoint = process.env.REACT_APP_API_BASE_URL + "/ico";

    async function updateDate(phase) {
        if (!selectedDate) {
            toast.error("Please select a date");
            return;
        }

        // Convert selectedDate to UTC
        const utcDate = new Date(selectedDate);
        const isoUtcDate = utcDate.toISOString(); // Convert to ISO format in UTC

        let data = {
            phase: phase,
            startDate: isoUtcDate, // Store as UTC ISO string
        };

        try {
            const response = await axios.patch(endpoint, data, config);
            console.log(response.data.data);
            toast.success("Date updated successfully!");
        } catch (err) {
            toast.error("Please try again");
        }
    }

    let config = {
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: process.env.REACT_APP_API_KEY,
        },
    };

    return (
        <div className="p-5">
            <DatePicker 
                label="Select Date" 
                value={selectedDate} 
                onChange={(newDate) => setSelectedDate(newDate)} 
            />
            <p className="mt-3 text-white">Phase 1 start Date (UTC): {selectedDate ? new Date(selectedDate).toUTCString() : "Not selected"}</p>
            <button className="btn-primary" onClick={() => updateDate(1)}>Change Phase 1 Start Date</button>
        </div>
    );
};
  
    
const ChangeDate2 = () => {
  const [selectedDate, setSelectedDate] = useState(null);

  const endpoint = process.env.REACT_APP_API_BASE_URL + "/ico";

  async function updateDate(phase) {
      if (!selectedDate) {
          toast.error("Please select a date");
          return;
      }

      // Convert selectedDate to UTC
      const utcDate = new Date(selectedDate);
      const isoUtcDate = utcDate.toISOString(); // Convert to ISO format in UTC

      let data = {
          phase: phase,
          startDate: isoUtcDate, // Store as UTC ISO string
      };

      try {
          const response = await axios.patch(endpoint, data, config);
          console.log(response.data.data);
          toast.success("Date updated successfully!");
      } catch (err) {
          toast.error("Please try again");
      }
  }

  let config = {
      headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: process.env.REACT_APP_API_KEY,
      },
  };

  return (
      <div className="p-5">
          <DatePicker 
              label="Select Date" 
              value={selectedDate} 
              onChange={(newDate) => setSelectedDate(newDate)} 
          />
          <p className="mt-3 text-white">Phase 2 start Date (UTC): {selectedDate ? new Date(selectedDate).toUTCString() : "Not selected"}</p>
          <button className="btn-primary" onClick={() => updateDate(2)}>Change Phase 2 Start Date</button>
      </div>
  );
};


  return (

    <div className='w-full !h-full  shadow-xl  rounded-lg border-neutral-500/20 border    bg-black/80 backdrop-blur-lg p-5'>
      <div className='flex  flex-col justify-between items-center gap-5 h-full'>
        <div className="flex w-full items-center justify-between">
          <div className="grid gap-2">
            <h1 className="heading-large">Admin Dashboard</h1>
          </div>

        </div>
        <hr className='w-full border-neutral-500/20 ' />

        <AdminControlls />
        {/* <hr className='w-full border-neutral-500/20 ' /> */}
        {/* <TokenInfos /> */}
      </div>
    </div>
  )

}